import http from '@/libs/http'
export default class OrdenesService {
  getOrdenes (params) {
    // return http.get(`${process.env.VUE_APP_MICROSERVICE_API_FACTURACION}/ordenes_venta`, { params, headers: { loading: true } })
    return http.get(`${process.env.VUE_APP_MICROSERVICE_API_UT_SEGUPHARMA_FACTURACION_MASIVA}/listar`, { params, headers: { loading: true } })
  }
}
